module.exports = __webpack_public_path__ + "media/V38.e9b44dd8.mp4";